import React, { useEffect } from 'react';
import { useDialog } from 'components/Dialog';
import { Heading, Box, Text, LoadingIndicator } from 'roo-ui/components';
import { useBeforeUnload, useInterval, useStateList } from 'react-use';

export const STEP_TRANSITION_INTERVAL_MS = 10000;
export const PROGRESS_MESSAGES = [
  "Please don't refresh this page while we process your reservation",
  'Almost there. Finalising your booking',
];

const BookingProgressDialog = () => {
  const { Dialog, openDialog, closeDialog } = useDialog();
  const { state, next, currentIndex } = useStateList(PROGRESS_MESSAGES);

  useBeforeUnload(true, 'Your reservation is in progress, are you sure?');

  useEffect(() => {
    openDialog();
    return () => {
      closeDialog();
    };
  }, [openDialog, closeDialog]);

  useInterval(
    () => {
      next();
    },
    currentIndex < PROGRESS_MESSAGES.length - 1 ? STEP_TRANSITION_INTERVAL_MS : null,
  );

  return (
    <Dialog>
      <Heading.h3 textAlign="center">We&apos;re confirming your booking</Heading.h3>
      <Box textAlign="center" mb={6}>
        <Text>{state}</Text>
      </Box>
      <LoadingIndicator />
    </Dialog>
  );
};

export default BookingProgressDialog;
